export class RestoreImageImageInput {
    'imageId';
    'devices';
    'rootDeviceName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "imageId",
            "baseName": "imageId",
            "type": "string",
            "format": ""
        },
        {
            "name": "devices",
            "baseName": "devices",
            "type": "Array<RestoreImageImageDeviceInput>",
            "format": ""
        },
        {
            "name": "rootDeviceName",
            "baseName": "rootDeviceName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreImageImageInput.attributeTypeMap;
    }
    constructor() {
    }
}
